module.exports = __webpack_public_path__ + "static/media/twitter-icon.ee3d1d33.svg";